$(document).ready(function () {
  /* ================= Header Sticky ================= */
  let header = $("header");
  let sticky = header.offset().top;

  $(window).on("scroll", function () {
    if (window.pageYOffset > sticky) {
      header.addClass("fixed");
    } else {
      header.removeClass("fixed");
    }
  });

  /* ================= Select Picker ================= */
  $(".selectpicker").selectpicker();

  /* ================= Search Modal ================= */
  $("#openSearch").on("click", function () {
    $("#searchModal").fadeIn(300).css("display", "flex");
    $("body").addClass("no-scroll");
    $(".search-input").focus();
  });

  $("#closeSearch").on("click", function () {
    $("#searchModal").fadeOut(300);
    $("body").removeClass("no-scroll");
  });

  $(document).on("keyup", function (e) {
    if (e.key === "Escape") {
      $("#closeSearch").trigger("click");
    }
  });

  /* ================= Thumbnail Switch ================= */
  $(".thumb").on("click", function () {
    let index = $(this).data("index");

    $(".thumb, .product-img, .content-item").removeClass("active");
    $(this).addClass("active");
    $(".product-img").eq(index).addClass("active");
    $(".content-item").eq(index).addClass("active");
  });

  /* ================= Option Card Select ================= */
  $(".option-card").on("click", function () {
    $(".option-card").removeClass("active");
    $(this).addClass("active");
    $(this).find("input").prop("checked", true);
  });

  /* ================= Slick Slider ================= */
  $(".thumb-slider").slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });

  /* ================= Image Modal ================= */
  $("#zoomModal").on("show.bs.modal", function () {
    $("#modalImg").attr("src", $("#mainImage").attr("src"));
  });

  /* ================= Mobile Menu ================= */
  let menuToggle = $("#menuToggle");
  let navWrapper = $("#navWrapper");
  let overlay = $("#overlay");
  let close_header = $(".close_header");

  function toggleMenu() {
    menuToggle.toggleClass("open");
    navWrapper.toggleClass("active");
    overlay.toggleClass("show");

    $("body").css(
      "overflow",
      navWrapper.hasClass("active") ? "hidden" : "auto",
    );
  }

  menuToggle.on("click", toggleMenu);
  overlay.on("click", toggleMenu);
  close_header.on("click", toggleMenu);

  $(".nav_link").on("click", function () {
    if (navWrapper.hasClass("active")) {
      toggleMenu();
    }
  });

  /* ================= Cart Toggle ================= */
  let cartOpen = false;
  let numberOfProducts = 0;

  $("body").on("click", ".cartBtn", function (e) {
    e.preventDefault();
    cartOpen ? closeCart() : openCart();
  });

  $("body").on("click", ".lightbox", function (e) {
    e.preventDefault();
    cartOpen ? closeCart() : openCart();
  });

  $("body").on("click", ".js-add-product", function () {
    numberOfProducts++;
  });

  $("body").on("click", ".js-remove-product", function () {
    if (numberOfProducts > 0) numberOfProducts--;
  });

  function openCart() {
    cartOpen = true;
    $("body").addClass("open");
  }

  function closeCart() {
    cartOpen = false;
    $("body").removeClass("open");
  }

  /* ================= Single Range Slider ================= */
  let slider = $("#myRange");

  function updateSlider() {
    let min = parseInt(slider.attr("min"));
    let max = parseInt(slider.attr("max"));
    let val = parseInt(slider.val());

    let percent = ((val - min) / (max - min)) * 100;

    slider.css(
      "background",
      `linear-gradient(
        to right,
        #e2b04a 0%,
        #e2b04a ${percent}%,
        #333 ${percent}%,
        #333 100%
      )`,
    );
  }

  // IMPORTANT: input event fires while dragging
  slider.on("input", function () {
    updateSlider();
  });

  // Initial paint
  updateSlider();

  /* ================= Price Range Slider (Converted to jQuery) ================= */
  // Initialize all price range sliders independently
  // $(".rangePriceWrap").each(function () {
  //   let container = $(this);
  //   let rangeInput = container.find(".range-input input");
  //   let priceInput = container.find(".price-input input");
  //   let range = container.find(".range_slider .progress");
  //   let priceGap = 1;

  //   priceInput.on("input", function () {
  //     let minPrice = parseInt(priceInput.eq(0).val());
  //     let maxPrice = parseInt(priceInput.eq(1).val());

  //     if (
  //       maxPrice - minPrice >= priceGap &&
  //       maxPrice <= rangeInput.eq(1).attr("max")
  //     ) {
  //       if ($(this).hasClass("input-min")) {
  //         rangeInput.eq(0).val(minPrice);
  //         range.css(
  //           "left",
  //           (minPrice / rangeInput.eq(0).attr("max")) * 100 + "%",
  //         );
  //       } else {
  //         rangeInput.eq(1).val(maxPrice);
  //         range.css(
  //           "right",
  //           100 - (maxPrice / rangeInput.eq(1).attr("max")) * 100 + "%",
  //         );
  //       }
  //     }
  //   });

  //   rangeInput.on("input", function () {
  //     let minVal = parseInt(rangeInput.eq(0).val());
  //     let maxVal = parseInt(rangeInput.eq(1).val());

  //     if (maxVal - minVal < priceGap) {
  //       if ($(this).hasClass("range-min")) {
  //         rangeInput.eq(0).val(maxVal - priceGap);
  //         minVal = maxVal - priceGap;
  //       } else {
  //         rangeInput.eq(1).val(minVal + priceGap);
  //         maxVal = minVal + priceGap;
  //       }
  //     }

  //     priceInput.eq(0).val(minVal);
  //     priceInput.eq(1).val(maxVal);

  //     range.css({
  //       left: (minVal / rangeInput.eq(0).attr("max")) * 100 + "%",
  //       right: 100 - (maxVal / rangeInput.eq(1).attr("max")) * 100 + "%",
  //     });
  //   });

  //   // Initial progress bar update
  //   let initialMin = parseInt(rangeInput.eq(0).val());
  //   let initialMax = parseInt(rangeInput.eq(1).val());
  //   range.css({
  //     left: (initialMin / rangeInput.eq(0).attr("max")) * 100 + "%",
  //     right: 100 - (initialMax / rangeInput.eq(1).attr("max")) * 100 + "%",
  //   });
  // });
});

/* ================= Change Main Image ================= */
function changeImage(element) {
  $("#mainImage").css("opacity", "0");

  setTimeout(() => {
    $("#mainImage").attr("src", element.src).css("opacity", "1");
  }, 200);

  $(".thumb-img").removeClass("active");
  $(element).addClass("active");
}

/* ================= Quantity Counter ================= */
function updateQty(btn, val) {
  let input = $(btn).siblings(".qtyInput");
  let current = parseInt(input.val()) || 1;

  if (current + val >= 1) {
    input.val(current + val);
  }
}

